"use client";

import { Platform, View } from "react-native";
import isWeb from "src/constants/isWeb";
import { GatheringContext } from "src/contexts/GatheringContext/GatheringContext";
import useDim from "src/hooks/useDim";
import useMountEffect from "src/hooks/useMountEffect";
import useRouter from "src/hooks/useRouter";
import { useInsideModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";
import { useStore } from "zustand";
import PhotoDetailMainDataManager from "./components/PhotoDetailDataManager/PhotoDetailMainDataManager";
import PhotoDetailTopDataManager from "./components/PhotoDetailDataManager/PhotoDetailTopDataManager";
import { usePhotoDetailModalDimensions } from "./PhotoDetailModalSkeleton";

const PhotoDetailModal = () => {
	const {
		props: { context, initialPhotoId },
	} = useInsideModal<GatheringModal["PhotoDetailModal"]>();
	const viewMode = useStore(context.store, (state) => state.viewMode);
	const filterUserIds = useStore(context.store, (state) => state.filterUserIds);
	const filterMode = useStore(context.store, (state) => state.filterMode);
	const style = usePhotoDetailModalDimensions();
	const router = useRouter();
	const identifier = useStore(context.store, (state) => state.identifier);
	useMountEffect(() => {
		return () => {
			if (isWeb) {
				const curUrl = window.location.href;
				if (curUrl.includes("/album/") && curUrl.includes("photo")) {
					router.replaceState(`/album/${identifier}`, {
						forwardParams: true,
						params: {
							photo: null,
						},
					});
				}
			}
		};
	}, []);
	const dim = useDim();

	return (
		<View
			style={[
				style,
				Platform.OS !== "android" && {
					// There's some issues caused by the browser bar
					maxHeight: dim.height,
				},
			]}
		>
			<GatheringContext.Provider value={context}>
				{viewMode === "Top" ? (
					<PhotoDetailTopDataManager initialPhotoId={initialPhotoId} />
				) : (
					<PhotoDetailMainDataManager
						initialPhotoId={initialPhotoId}
						filterMode={filterMode}
					/>
				)}
			</GatheringContext.Provider>
		</View>
	);
};
export default PhotoDetailModal;
